import AdminDashboard from "./AdminDashboard";
import StudentDashboard from "./StudentDashboard";

export default function Dashboard() {
  const role = localStorage.getItem("role");
  return role === "student" ? <StudentDashboard /> : <AdminDashboard />;
}
